/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import {
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  FormLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  InputAdornment,
  TextField,
  Drawer,
  IconButton
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import dateFormat from 'dateformat';
import { Close } from '@mui/icons-material';
import globalAction from '../../store/actions/GlobalAction';
import PaymentAction from '../../store/actions/PaymentAction';
import ClientAction from '../../store/actions/ClientAction';

// import Logo from '../../assets/images/logo_image.png';
import Loader from '../../utils/errorPages/Loader';

const validationSchema = Yup.object({
  type: Yup.string().required(),

  scheduled_at: Yup.date()
    .nullable()
    .when('type', {
      is: 'schedule',
      then: (schema) => schema.required('Schedule date cannot be empty'),
      otherwise: (schema) => schema.notRequired()
    })
});

// Mail designs previewable from a single invoice. Keys must match the
// `template` values accepted by InvoiceController::previewMailTemplate().
const MAIL_PREVIEW_TABS = [
  { key: 'invoice', label: 'Invoice' },
  { key: 'paid', label: 'Paid' },
  { key: 'failed', label: 'Failed' },
  { key: 'cancel', label: 'Cancelled' },
  { key: 'reminder', label: 'Reminder' },
  { key: 'pdf', label: 'PDF' }
];

function PaymentRequestPreview() {
  const [clientInfo, setClientInfo] = useState([]);
  const [payInfo, setPayInfo] = useState({});
  const [mailContentValue, setMailContentValue] = useState('');
  // Which design the drawer is showing, plus the invoice PDF download link.
  const [mailTemplate, setMailTemplate] = useState('invoice');
  const [pdfUrl, setPdfUrl] = useState('');
  // Testing-only: send the previewed design to an arbitrary address.
  const [testEmail, setTestEmail] = useState('');
  const [sendingTest, setSendingTest] = useState(false);
  const { code } = useParams();
  const [velanAddress, setVelanAddress] = useState({});
  const { addressData } = useSelector((state) => state.global);
  const { paymentItemData, isLoading } = useSelector((state) => state.payment);
  const { companyClientData } = useSelector((state) => state.client);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [submitAction, setSubmitAction] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { REACT_APP_API_URL } = process.env;

  useEffect(() => {
    if (code) {
      dispatch(PaymentAction.getItem(code));
    }
  }, [dispatch, code]);

  useEffect(() => {
    dispatch(globalAction.getAddress());
  }, [dispatch]);

  useEffect(() => {
    if (paymentItemData) {
      setPayInfo(paymentItemData);
      if (paymentItemData?.company && paymentItemData?.company._id) {
        dispatch(ClientAction.getCompanyClient(paymentItemData?.company._id));
      }
    }
  }, [paymentItemData]);

  useEffect(() => {
    if (paymentItemData && companyClientData) {
      const clientData = companyClientData.find(
        (item) => item.email === paymentItemData?.client?.email
      );
      setClientInfo(clientData);
    }

    if (paymentItemData && addressData) {
      const address = addressData.find(
        (item) => item.address_type === paymentItemData?.address?.address_type
      );
      setVelanAddress(address);
    }
  }, [paymentItemData, companyClientData, addressData]);

  useEffect(() => {
    if (clientInfo) {
      setPayInfo((prevValues) => ({
        ...prevValues,
        primary_email: clientInfo?.email || '',
        department_id: clientInfo?.departments || []
      }));
    }
  }, [clientInfo]);

  // Each design is rendered server-side from this same invoice, so switching
  // tabs re-fetches rather than filtering anything client-side.
  const loadMailPreview = (template) => {
    setMailTemplate(template);
    dispatch(
      PaymentAction.previewMail(code, { template }, setDrawerOpen, setMailContentValue, setPdfUrl)
    );
  };

  const handlePreview = () => loadMailPreview('invoice');

  // Sends whichever design is currently selected in the drawer.
  const handleSendTestMail = () => {
    dispatch(
      PaymentAction.sendPreviewMail(
        code,
        { email: testEmail, template: mailTemplate },
        setSendingTest
      )
    );
  };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper viewPaymentRequest">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/payment-request">
            Payment Request
          </Typography>
          <Typography component="h2" variant="h2">
            / Preview
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={{
          scheduled_at: null,
          type: 'send'
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values, { setErrors, setSubmitting, setFieldError, setFieldTouched }) => {
          if (submitAction === 'schedule') {
            if (!values.scheduled_at) {
              setFieldError('scheduled_at', 'Schedule date is required');
              setFieldTouched('scheduled_at', true);
              setSubmitting(false);
              return;
            }
            const payload = {
              ...values,
              scheduled_at: dateFormat(values.scheduled_at, 'yyyy-mm-dd HH:MM:ss'),
              type: 'schedule'
            };
            dispatch(
              PaymentAction.updatePreview(code, payload, setErrors, setSubmitting, navigate)
            );
            return; // ⬅️ prevent double dispatch
          }

          const { scheduled_at: scheduledAt, ...payload } = values;

          dispatch(PaymentAction.updatePreview(code, payload, setErrors, setSubmitting, navigate));
          // .unwrap()
          // .then(() => {
          //   console.log('view');
          //   navigate(`/payment-request/view/${code}`);
          // })
          // .catch((res) => {
          //   setErrors(res?.error || {});
          // })
          // .finally(() => {
          //   setSubmitting(false);
          // });
        }}
      >
        {({ handleSubmit, isSubmitting, errors, touched, values, setFieldValue }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={8} lg={8}>
                <Card>
                  {/* The global .MuiCardHeader-content .MuiTypography-root rule in
                      style.css styles the subheader exactly like the title (16px/700),
                      so it reads as a second heading. Scope it back down here rather
                      than in style.css, which other cards rely on. !important is
                      needed to outweigh that 5-class selector. */}
                  <CardHeader
                    title="Invoice Mail"
                    subheader="Uses a fixed template — click Preview to see it with this invoice's details."
                    subheaderTypographyProps={{
                      sx: {
                        fontSize: '13px !important',
                        fontWeight: '400 !important',
                        color: '#8a8a94 !important',
                        lineHeight: '20px !important',
                        mt: 0.5
                      }
                    }}
                    sx={{ alignItems: 'flex-start' }}
                    action={
                      <Button
                        variant="contained"
                        onClick={handlePreview}
                        size="small"
                        color="primary"
                      >
                        Preview
                      </Button>
                    }
                  />
                  <CardContent>
                    <Grid container>
                      <Grid item md={8} lg={8}>
                        <Box className="velanAddressInfo">
                          {velanAddress?.logo && (
                            <img
                              src={`${REACT_APP_API_URL}/${velanAddress.logo}`}
                              alt="Velan Logo"
                              width="180"
                              height="45"
                            />
                          )}
                          <Typography className="" component="p" variant="body1">
                            {velanAddress?.full_address}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={4}>
                        {/* Each pair renders only when it has a value, and the label is
                            kept on one line so it never breaks before its colon. */}
                        {payInfo?.invoice_number ? (
                          <Typography variant="body1" component="p">
                            <FormLabel sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                              Invoice Number :
                            </FormLabel>
                            {payInfo.invoice_number}
                          </Typography>
                        ) : null}
                        {payInfo?.invoice_date ? (
                          <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                            <FormLabel sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                              Invoice Date :
                            </FormLabel>
                            {payInfo.invoice_date}
                          </Typography>
                        ) : null}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Card sx={{ mt: 2 }}>
                  <CardHeader title="Billing Details" />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={8} lg={8}>
                        <Typography variant="body1" component="p">
                          <b>{payInfo?.client?.name || ''}</b>
                        </Typography>
                        <Typography variant="body1" component="p">
                          {payInfo?.company?.name || ''}
                        </Typography>
                        {/* clientInfo starts out as [], which is truthy — so test for a
                            real field instead of the object itself. */}
                        {clientInfo?.address_1 || clientInfo?.city ? (
                          <Typography className="" component="p" variant="body1">
                            {clientInfo?.address_1}
                            {clientInfo?.address_2 ? (
                              <>
                                <br />
                                {clientInfo.address_2}
                              </>
                            ) : null}
                            {clientInfo?.address_1 || clientInfo?.address_2 ? <br /> : null}
                            {/* Skip blank parts so a missing state/postcode renders
                                nothing rather than "null" or a stray ", " / " - ". */}
                            {[
                              [clientInfo?.city, clientInfo?.state?.name, clientInfo?.country?.name]
                                .filter(Boolean)
                                .join(', '),
                              clientInfo?.postal_code
                            ]
                              .filter(Boolean)
                              .join(' - ')}
                          </Typography>
                        ) : null}
                        <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                          {payInfo?.primary_email || ''}
                        </Typography>
                        <Typography variant="body1" component="p">
                          {payInfo?.invoice_email &&
                            payInfo?.invoice_email.map((item) => item).join(', ')}
                        </Typography>
                      </Grid>
                      <Grid item md={4} lg={4}>
                        {payInfo?.paymentRequestType?.type ? (
                          <Typography variant="body1" component="p">
                            <FormLabel sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                              Payment Request type :
                            </FormLabel>
                            {payInfo.paymentRequestType.type}
                          </Typography>
                        ) : null}
                        {/* Drops the bare "Client Approval Date :" label when unset. */}
                        {payInfo?.client_approval_date ? (
                          <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                            <FormLabel sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                              Client Approval Date :
                            </FormLabel>
                            {payInfo.client_approval_date}
                          </Typography>
                        ) : null}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Card sx={{ mt: 2 }}>
                  <CardHeader title="Inovice Details" />
                  <CardContent>
                    <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell component="th">Service From</TableCell>
                              <TableCell component="th">Service To</TableCell>
                              <TableCell component="th">Description</TableCell>
                              <TableCell component="th">Qty</TableCell>
                              <TableCell component="th">UOM</TableCell>
                              <TableCell component="th">Rate</TableCell>
                              <TableCell component="th">Amount</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {payInfo?.details &&
                              payInfo?.details.map((item, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {item?.services.map((serviceitem, i) => {
                                      return (
                                        <TableRow key={`${index}-${i}`}>
                                          {i === 0 ? (
                                            <>
                                              <TableCell>{item.services_from}</TableCell>
                                              <TableCell>{item.services_to}</TableCell>
                                            </>
                                          ) : (
                                            <>
                                              <TableCell> </TableCell>
                                              <TableCell> </TableCell>
                                            </>
                                          )}
                                          <TableCell component="td">
                                            {serviceitem.service_description}
                                          </TableCell>
                                          <TableCell component="td">
                                            {serviceitem.quantity}
                                          </TableCell>
                                          <TableCell component="td">
                                            {serviceitem?.unit_measurement_id?.name}
                                          </TableCell>
                                          <TableCell component="td">{serviceitem.rate}</TableCell>
                                          <TableCell component="td">
                                            {`${payInfo?.currency?.short_name} ${serviceitem.amount}`}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </React.Fragment>
                                );
                              })}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TableCell colSpan="5"> </TableCell>
                              <TableCell component="th">Total</TableCell>
                              <TableCell align="left" component="th">
                                {`${payInfo?.currency?.short_name} ${payInfo?.grand_total}`}
                              </TableCell>
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={4} lg={4}>
                <Card>
                  <CardHeader title="Currency and Payments" />
                  <CardContent>
                    <Typography variant="body1" component="p" sx={{ mt: 0 }}>
                      <FormLabel sx={{ mr: 1 }}>Currency:</FormLabel>
                      {payInfo?.currency?.short_name || ''}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>Payment Method:</FormLabel>
                      {payInfo?.paymentMethod &&
                        payInfo?.paymentMethod.map((item) => item.name).join(', ')}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>Status:</FormLabel>
                      {payInfo?.status_name ? (
                        <Chip
                          sx={{
                            p: 0.25,
                            pt: 0.5,
                            mr: 0.5,
                            width: 'auto',
                            height: 'auto',
                            '.MuiChip-label': {
                              fontSize: '13px',
                              letterSpacing: '0.5px',
                              opacity: 1
                            }
                          }}
                          color={payInfo?.status_name.toLowerCase().replace(/\s+/g, '')}
                          label={payInfo?.status_name || ''}
                        />
                      ) : (
                        ''
                      )}
                    </Typography>
                  </CardContent>
                </Card>
                {submitAction === 'schedule' && (
                  <Card className="scheduledWrapper" sx={{ mt: 2 }}>
                    <CardHeader title="Schedule" />
                    <CardContent>
                      <DatePicker
                        style={{ width: '100%' }}
                        selected={values.scheduled_at}
                        name="scheduled_at" // Adding the name attribute here
                        // dateFormat="dd MMM yyyy"
                        dateFormat="dd MMM yyyy h:mm aa"
                        showTimeSelect
                        minDate={addDays(new Date(), 1)}
                        onChange={(date) => {
                          // const newDate = dateFormat(date, 'yyyy-mm-dd');
                          setFieldValue('scheduled_at', date);
                        }}
                        // isClearable
                        customInput={
                          <TextField
                            label="Schedule Date"
                            error={touched.scheduled_at && Boolean(errors.scheduled_at)}
                            helperText={touched.scheduled_at && errors.scheduled_at}
                            fullWidth
                            size="small"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: true }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    disabled
                                    // color="secondary"
                                  >
                                    <CalendarMonthIcon sx={{ color: '#fff' }} />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        }
                      />
                    </CardContent>
                  </Card>
                )}

                <Card sx={{ mt: 2 }}>
                  <CardContent>
                    {payInfo?.status === 5 && (
                      <Button
                        type="submit"
                        className="save__btn"
                        variant="contained"
                        sx={{ mb: 2 }}
                        color="scheduled"
                        onClick={() => {
                          setSubmitAction('schedule');
                          setFieldValue('type', 'schedule');
                        }}
                        fullWidth
                        disabled={isSubmitting && submitAction === 'schedule'}
                        size="large"
                      >
                        {isSubmitting && submitAction === 'schedule' ? (
                          <CircularProgress size={20} />
                        ) : (
                          'Schecdule'
                        )}
                      </Button>
                    )}
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={() => {
                        setSubmitAction('send');
                        setFieldValue('type', 'send');
                      }}
                      disabled={isSubmitting && submitAction === 'send'}
                      size="large"
                    >
                      {isSubmitting && submitAction === 'send' ? (
                        <CircularProgress size={20} />
                      ) : (
                        'Save and Send'
                      )}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      fullWidth
                      sx={{ mt: 2 }}
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={() => {
                        navigate(`/payment-request/edit/${code}`);
                      }}
                    >
                      Back
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      <Drawer
        className="previewModal"
        variant="temporary"
        anchor="right"
        open={drawerOpen}
        sx={{
          flexShrink: 0,
          zIndex: 1205
        }}
      >
        <Box>
          <Card>
            <CardHeader
              sx={{ textAlign: 'left !important' }}
              title="Mail Preview"
              action={
                <IconButton
                  aria-label="settings"
                  onClick={() => {
                    setDrawerOpen(false);
                  }}
                >
                  <Close />
                </IconButton>
              }
            />
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }}
              >
                {MAIL_PREVIEW_TABS.map((tab) => (
                  <Button
                    key={tab.key}
                    size="small"
                    variant={mailTemplate === tab.key ? 'contained' : 'outlined'}
                    onClick={() => loadMailPreview(tab.key)}
                  >
                    {tab.label}
                  </Button>
                ))}
                {pdfUrl && (
                  <Button
                    size="small"
                    color="secondary"
                    variant="outlined"
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    sx={{ ml: 'auto' }}
                  >
                    Download PDF
                  </Button>
                )}
              </Box>
              {/* Testing aid: mails whichever design is selected above. */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1,
                  mb: 2,
                  pb: 2,
                  borderBottom: '1px solid #ececf2'
                }}
              >
                <TextField
                  size="small"
                  label="Send test to"
                  placeholder="you@example.com"
                  value={testEmail}
                  onChange={(e) => setTestEmail(e.target.value)}
                  helperText={`Testing purpose only — sends the "${
                    MAIL_PREVIEW_TABS.find((t) => t.key === mailTemplate)?.label || 'Invoice'
                  }" design to this address, never to the client.`}
                  sx={{ minWidth: 280 }}
                />
                <Button
                  variant="outlined"
                  onClick={handleSendTestMail}
                  size="small"
                  color="secondary"
                  disabled={sendingTest || !testEmail || mailTemplate === 'pdf'}
                  sx={{ mt: 0.25 }}
                >
                  {sendingTest ? 'Sending…' : 'Send'}
                </Button>
              </Box>
              <Box dangerouslySetInnerHTML={{ __html: mailContentValue }} />
            </CardContent>
          </Card>
        </Box>
      </Drawer>
    </Box>
  );
}
export default PaymentRequestPreview;
